/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
function ValidateEmail(mail) 
{
 if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail))
  {
    return (true)
  }
    alert("You have entered an invalid email address!")
    return (false)
}
function formatPhoneNumber(phoneNumberString) {
  var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
  var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return '(' + match[1] + ') ' + match[2] + '-' + match[3];
  }
  return null;
}
$(document).ready(function(){
  $('.contactnumber').html(formatPhoneNumber($('.contactnumber').html()));
  $('#Subscribe').click(function(e){
    e.preventDefault();
    if($('.newsletter__input').val() == '' ){
      $('.error-newsletter').show();
    }else if(!ValidateEmail($('.newsletter__input').val())){
      $('.error-newsletter').show();
    }else{
      $('.error-newsletter').hide();
      $('#newsletter').submit();
    }
  });

  logoCarouselInitDesk($(".js-home-product-list-carousel"), 3 , false);
  setTimeout(function(){
    if($('.home-product-list .home-product-list__items ').length == 1) {
      jQuery('.home-product-list .home-product-name').matchHeight();
    }
      jQuery('#shopify-section-product-recommendations .product__title').matchHeight();
      if ($(".js-layout-slider-product-recommendations").hasClass("slick-initialized")) {
        //detach slick
        $(".js-layout-slider-product-recommendations").slick("unslick");
      }
      logoCarouselInitDesk($(".js-layout-slider-product-recommendations"), 4 , true);      
    },1000); 
    setInterval(function(){
      if ($('.spr-loaded').length == 0) {
        if($('.spr-badge').length == 1) {
          var ratings = $('.spr-badge').data('rating'); 
          if(ratings.toString().split(".")[1].length > 2){
            ratings = ratings.toFixed(2);
          }
          
          if(ratings == 0 || ratings == '0.0' ){
            $('.spr-summary').prepend('<span class="totalrating">'+ratings+'</span>');
            $('.spr-summary').prepend('<span class="spr-starrating spr-summary-starrating"><i class="spr-icon spr-icon-star-empty" style="color: #d7a461;"></i><i class="spr-icon spr-icon-star-empty" style="color: #d7a461;"></i><i class="spr-icon spr-icon-star-empty" style="color: #d7a461;"></i><i class="spr-icon spr-icon-star-empty" style="color: #d7a461;"></i><i class="spr-icon spr-icon-star-empty" style="color: #d7a461;"></i></span>');
          }else{
            $('<span class="totalrating">'+ratings+'</span>').insertAfter('.spr-summary-starrating');
          }   
          $('#shopify-product-reviews').addClass('spr-loaded'); 
          $('.spr-container').addClass('spr-loaded');    
        }
        $('.spr-review').each(function(){
          var name = $(this).find('.author').html();
          var date = $(this).find('.date').html();
          const myArr = name.split(" ");
          var fnc = myArr[0].charAt(0); 
          var lnc = myArr[1].charAt(0); 
          $(this).prepend('<span class="nameicon">'+fnc+lnc+'</span>');
          $(this).find('.spr-review-content').append('<span class="date">'+date+'</span>');
        });
      }
    }, 1000);  
})


function logoCarouselInitDesk($carousel, slideCount, hasarrows) {
    $carousel.not(".slick-initialized").slick({ 
        slidesToShow: slideCount,
        slidesToScroll: 1,
        arrows: hasarrows,
        dots: false,
        fade: false,
        adaptiveHeight: false,
        speed: 300,
        cssEase: "ease",
        lazyLoad: "progressive",
        infinite:false,
        centerMode:false,
        centerPadding: '80px',        
        prevArrow: $('.prev'),
        nextArrow: $('.next'),
        responsive: [
            {
              breakpoint: 1024,
              settings: {
                arrows: true,
                centerMode: false,
                adaptiveHeight: true,
                centerPadding: '40px',
                slidesToShow: 2
              }
            },
            {
              breakpoint: 480,
              settings: {
                arrows: true,
                adaptiveHeight: true,
                centerMode: true,
                centerPadding: '40px',
                slidesToShow: 1 
              }
            }
        ]
    });
}
 